var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuanteralogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 50,
    viewBox: "0 0 192 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M182.39 27.8066C182.296 27.4057 182.202 26.9576 182.154 26.4859C182.107 26.0142 182.084 25.4245 182.084 24.7406H181.966V17.4293C181.966 16.6274 181.73 16.0142 181.282 15.6132C180.833 15.1887 180.149 14.9764 179.23 14.9764C178.333 14.9764 177.602 15.1415 177.06 15.4953C176.541 15.8255 176.21 16.2972 176.092 16.9104H172.436C172.602 15.4717 173.286 14.316 174.489 13.4434C175.691 12.5472 177.319 12.1227 179.348 12.1227C181.47 12.1227 183.051 12.5943 184.159 13.5613C185.244 14.5047 185.787 15.8962 185.787 17.7594V24.7406C185.787 25.2123 185.81 25.7076 185.881 26.2264C185.952 26.7217 186.07 27.2642 186.211 27.8302H182.39V27.8066ZM177.06 28.0896C175.503 28.0896 174.276 27.7123 173.356 26.934C172.46 26.1557 171.988 25.0943 171.988 23.7972C171.988 22.3821 172.507 21.2736 173.521 20.4481C174.536 19.6226 175.998 19.0802 177.861 18.7972L182.673 18.066V20.4717L178.498 21.1085C177.602 21.25 176.918 21.5094 176.446 21.8632C175.998 22.217 175.786 22.7359 175.786 23.3727C175.786 23.9623 175.998 24.4104 176.423 24.7406C176.847 25.0472 177.437 25.1887 178.168 25.1887C179.253 25.1887 180.149 24.9057 180.881 24.3632C181.612 23.8208 181.966 23.1604 181.966 22.3821L182.39 24.717C181.989 25.8255 181.329 26.6745 180.409 27.2642C179.513 27.8066 178.38 28.0896 177.06 28.0896Z",
    fill: "#DFEFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M161.563 27.8066V12.4057H165.266V16.1085H165.36V27.783H161.563V27.8066ZM165.36 19.7642L164.959 16.1085C165.313 14.8114 165.926 13.7972 166.799 13.1132C167.672 12.4293 168.71 12.0755 169.913 12.0755C170.337 12.0755 170.644 12.1227 170.809 12.1934V15.8019C170.715 15.7547 170.573 15.7312 170.384 15.7312C170.196 15.7076 169.983 15.7076 169.724 15.7076C168.262 15.7076 167.153 16.0378 166.422 16.6746C165.738 17.3349 165.36 18.3491 165.36 19.7642Z",
    fill: "#DFEFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M151.232 28.0896C149.604 28.0896 148.165 27.7359 146.939 27.0519C145.736 26.368 144.792 25.4246 144.108 24.2217C143.448 23.0189 143.118 21.6274 143.118 20.0472C143.118 18.467 143.448 17.0991 144.108 15.9198C144.792 14.717 145.736 13.7736 146.939 13.1132C148.142 12.4293 149.557 12.0755 151.161 12.0755C152.694 12.0755 154.015 12.4057 155.147 13.0425C156.279 13.6557 157.152 14.5519 157.765 15.7076C158.379 16.8632 158.709 18.184 158.709 19.717C158.709 20 158.709 20.2595 158.685 20.4953C158.662 20.7312 158.638 20.967 158.591 21.2264H145.453V18.5849H155.666L154.888 19.3161C154.888 17.8774 154.557 16.7689 153.897 16.0613C153.237 15.3302 152.317 14.9764 151.114 14.9764C149.816 14.9764 148.802 15.4246 148.024 16.2972C147.269 17.1934 146.915 18.467 146.915 20.1415C146.915 21.7925 147.293 23.0661 148.024 23.9387C148.779 24.8113 149.864 25.2359 151.255 25.2359C152.057 25.2359 152.765 25.0944 153.378 24.7878C153.991 24.4812 154.416 24.033 154.699 23.3963H158.284C157.789 24.8349 156.916 25.9906 155.713 26.8397C154.534 27.6887 153.048 28.0896 151.232 28.0896Z",
    fill: "#DFEFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M139.438 28.0896C137.551 28.0896 136.136 27.6415 135.239 26.7689C134.343 25.8727 133.919 24.5047 133.919 22.7123V8.89153L137.763 7.47644V22.8066C137.763 23.5613 137.976 24.1038 138.377 24.4576C138.777 24.8113 139.414 25 140.287 25C140.641 25 140.924 24.9764 141.183 24.9293C141.466 24.8585 141.726 24.7878 141.962 24.717V27.6651C141.726 27.783 141.372 27.8774 140.924 27.9481C140.476 28.0661 139.98 28.0896 139.438 28.0896ZM130.947 15.401V12.4057H141.938V15.401H130.947Z",
    fill: "#DFEFFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M114.601 27.8066V12.4057H118.304V16.0378H118.398V27.8066H114.601ZM125.404 27.8066V18.0661C125.404 17.1227 125.168 16.4151 124.672 15.9198C124.201 15.4481 123.493 15.1887 122.549 15.1887C121.748 15.1887 121.016 15.3774 120.379 15.7312C119.766 16.0849 119.271 16.6038 118.893 17.2406C118.54 17.8774 118.375 18.6321 118.375 19.4812L118.021 15.8019C118.54 14.6698 119.318 13.7736 120.309 13.1132C121.323 12.4293 122.526 12.0755 123.941 12.0755C125.616 12.0755 126.913 12.5472 127.833 13.4906C128.777 14.434 129.248 15.684 129.248 17.2642V27.7595H125.404V27.8066Z",
    fill: "#DFEFFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M107.359 27.8066C107.265 27.4057 107.171 26.9576 107.123 26.4859C107.076 26.0142 107.053 25.4245 107.053 24.7406H106.935V17.4293C106.935 16.6274 106.699 16.0142 106.251 15.6132C105.802 15.1887 105.118 14.9764 104.199 14.9764C103.302 14.9764 102.571 15.1415 102.029 15.4953C101.51 15.8255 101.179 16.2972 101.061 16.9104H97.4054C97.5705 15.4717 98.2546 14.316 99.4575 13.4434C100.66 12.5472 102.288 12.1227 104.316 12.1227C106.439 12.1227 108.02 12.5943 109.128 13.5613C110.213 14.5047 110.756 15.8962 110.756 17.7594V24.7406C110.756 25.2123 110.779 25.7076 110.85 26.2264C110.921 26.7217 111.039 27.2642 111.18 27.8302H107.359V27.8066ZM102.029 28.0896C100.472 28.0896 99.2452 27.7123 98.3253 26.934C97.429 26.1557 96.9573 25.0943 96.9573 23.7972C96.9573 22.3821 97.4762 21.2736 98.4904 20.4481C99.5283 19.6226 100.967 19.0802 102.83 18.7972L107.642 18.066V20.4717L103.467 21.1085C102.571 21.25 101.887 21.5094 101.415 21.8632C100.967 22.217 100.755 22.7359 100.755 23.3727C100.755 23.9623 100.967 24.4104 101.392 24.7406C101.816 25.0472 102.406 25.1887 103.137 25.1887C104.222 25.1887 105.118 24.9057 105.85 24.3632C106.581 23.8208 106.935 23.1604 106.935 22.3821L107.359 24.717C106.958 25.8255 106.298 26.6745 105.378 27.2642C104.458 27.8066 103.349 28.0896 102.029 28.0896Z",
    fill: "#DFEFFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8806 28.0896C83.8192 28.0896 82.8993 27.8774 82.0973 27.4293C81.3425 26.9576 80.7292 26.3444 80.3047 25.566C79.9037 24.7877 79.6914 23.8915 79.6914 22.901V12.4057H83.489V22.1227C83.489 23.066 83.7248 23.7736 84.173 24.2689C84.6447 24.7406 85.3288 25 86.2015 25C86.9799 25 87.6639 24.8113 88.2536 24.4576C88.8668 24.1038 89.3386 23.5849 89.6688 22.9481C90.0226 22.2877 90.2113 21.533 90.2113 20.7076L90.6123 24.3868C90.117 25.5189 89.3622 26.4151 88.3479 27.0991C87.3808 27.7594 86.2251 28.0896 84.8806 28.0896ZM90.3764 27.8066V24.1745H90.2585V12.4057H94.1032V27.8066H90.3764Z",
    fill: "#DFEFFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6571 28.0896C63.4635 28.0896 61.5294 27.6179 59.8547 26.6745C58.2036 25.7076 56.9063 24.3868 55.9864 22.6887C55.0665 20.9906 54.5947 19.0566 54.5947 16.8396C54.5947 14.6462 55.0665 12.7123 55.9864 11.0849C56.9063 9.4104 58.18 8.11323 59.8311 7.19341C61.4822 6.25002 63.3456 5.77832 65.4448 5.77832C67.5677 5.77832 69.4547 6.25002 71.0822 7.19341C72.7333 8.11323 74.0306 9.4104 74.9505 11.0849C75.8704 12.7595 76.3422 14.6934 76.3422 16.8868C76.3422 18.3491 76.1063 19.7406 75.6109 21.0613C75.1392 22.3585 74.3844 23.4434 73.3702 24.3632C72.3559 25.2595 71.0586 25.9198 69.4547 26.3208L65.6571 28.0896ZM65.4448 25.0472C66.8129 25.0472 68.0159 24.717 69.0301 24.0566C70.0679 23.3727 70.8935 22.4057 71.4832 21.1557C72.0729 19.9057 72.3559 18.467 72.3559 16.8161C72.3559 15.2359 72.0729 13.8679 71.4832 12.7123C70.9171 11.533 70.1151 10.6132 69.0773 9.97643C68.0394 9.31606 66.8365 8.98587 65.4448 8.98587C64.0768 8.98587 62.8738 9.31606 61.8124 9.97643C60.7746 10.6132 59.9962 11.533 59.4301 12.6887C58.864 13.8444 58.581 15.2359 58.581 16.8161C58.581 18.4906 58.864 19.9528 59.4301 21.2028C60.0198 22.4293 60.8218 23.3962 61.836 24.0802C62.8974 24.717 64.1004 25.0472 65.4448 25.0472ZM65.6571 28.0896L65.4684 25.3774L77.3564 24.6934V27.8066C76.0827 27.8066 74.9741 27.8066 74.007 27.8302C73.0635 27.8774 72.1672 27.901 71.3181 27.9481C70.4925 27.9953 69.6198 28.0189 68.7235 28.0425C67.8272 28.0896 66.8129 28.0896 65.6571 28.0896Z",
    fill: "#DFEFFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3451 35.5661C59.0527 35.5661 59.6424 35.8019 60.1142 36.2736C60.5859 36.7453 60.8218 37.3349 60.8218 38.0425C60.8218 38.75 60.5859 39.3396 60.1142 39.8113C59.6424 40.283 59.0527 40.5189 58.3451 40.5189H56.3166V43.467H55.5146V35.5425H58.3451V35.5661ZM58.3451 39.8113C58.8404 39.8113 59.2414 39.6463 59.5481 39.3161C59.8783 38.9859 60.0434 38.5613 60.0434 38.0661C60.0434 37.5708 59.8783 37.1463 59.5481 36.8161C59.2414 36.4859 58.8169 36.3208 58.3451 36.3208H56.3166V39.8113H58.3451Z",
    fill: "#F1FAFF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7137 43.6321C63.8881 43.6321 63.1805 43.3491 62.5908 42.783C62.0247 42.217 61.7417 41.5095 61.7417 40.6604C61.7417 39.8113 62.0247 39.1274 62.5908 38.5613C63.1569 37.9953 63.8881 37.7123 64.7137 37.7123C65.5392 37.7123 66.2469 37.9953 66.813 38.5613C67.3791 39.1274 67.6857 39.8349 67.6857 40.6604C67.6857 41.5095 67.4026 42.1934 66.813 42.783C66.2469 43.3491 65.5392 43.6321 64.7137 43.6321ZM64.7137 42.9245C65.327 42.9245 65.8695 42.7123 66.294 42.2878C66.7186 41.8396 66.9309 41.3208 66.9309 40.684C66.9309 40.0472 66.7186 39.5283 66.294 39.1038C65.8695 38.6557 65.327 38.4434 64.7137 38.4434C64.1004 38.4434 63.5579 38.6557 63.1334 39.1038C62.7088 39.5283 62.4965 40.0708 62.4965 40.684C62.4965 41.2972 62.7088 41.8396 63.1334 42.2878C63.5579 42.6887 64.1004 42.9245 64.7137 42.9245Z",
    fill: "#F1FAFF"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5402 37.8302H76.3185L74.5731 43.4906H73.7475L72.2851 38.9387L70.8227 43.4906H69.9972L68.2517 37.8302H69.0301L70.4217 42.5236L71.9077 37.8302H72.6625L74.1485 42.5236L75.5402 37.8302Z",
    fill: "#F1FAFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M82.074 38.6085C82.5929 39.1981 82.8524 39.9057 82.8524 40.7076C82.8524 40.7783 82.8524 40.9198 82.8288 41.0613H77.8519C77.9934 42.1934 78.8897 42.9245 80.1162 42.9245C80.9654 42.9245 81.6258 42.5472 81.9325 41.9576L82.5929 42.3349C82.0976 43.1368 81.2013 43.6321 80.0927 43.6321C79.1963 43.6321 78.4651 43.3491 77.9226 42.783C77.3565 42.217 77.0735 41.5094 77.0735 40.6604C77.0735 39.8113 77.3565 39.1038 77.899 38.5377C78.4651 37.9717 79.1492 37.6887 80.0219 37.6887C80.8946 37.7123 81.5551 37.9953 82.074 38.6085ZM77.8519 40.3302H82.074C82.0032 39.7406 81.7673 39.2689 81.39 38.9387C81.0126 38.6085 80.5408 38.4434 80.0455 38.4434C78.8661 38.4198 78.017 39.1981 77.8519 40.3302Z",
    fill: "#F1FAFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7863 38.7736C85.1401 38.0896 85.7298 37.7359 86.5789 37.7359V38.467C85.5411 38.467 84.7863 39.033 84.7863 40.3538V43.4906H84.0315V37.8302H84.7863V38.7736Z",
    fill: "#F1FAFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5933 36.8632C87.381 36.651 87.381 36.2972 87.5933 36.0849C87.8056 35.8727 88.1594 35.8727 88.3717 36.0849C88.584 36.2972 88.584 36.651 88.3717 36.8632C88.1594 37.0755 87.8056 37.0755 87.5933 36.8632ZM87.5933 43.4906V37.8302H88.3481V43.4906H87.5933Z",
    fill: "#F1FAFF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7873 40.0236V43.4906H94.0326V40.0236C94.0326 39.0094 93.4665 38.4198 92.4994 38.4198C91.4144 38.4198 90.6596 39.0802 90.6596 40.5189V43.4906H89.9048V37.8302H90.6596V38.7028C91.0841 38.0189 91.721 37.6887 92.5701 37.6887C93.9382 37.7123 94.7873 38.6085 94.7873 40.0236Z",
    fill: "#F1FAFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M101.109 37.8302H101.864V43.2547C101.864 44.0802 101.581 44.717 101.014 45.1887C100.448 45.6604 99.7879 45.8963 99.0095 45.8963C97.6886 45.8963 96.7923 45.4246 96.3206 44.5047L96.981 44.1274C97.3112 44.8113 97.9953 45.1651 99.0095 45.1651C100.307 45.1651 101.109 44.434 101.109 43.2547V42.3821C100.59 43.2076 99.8351 43.6321 98.8208 43.6321C98.0188 43.6321 97.3348 43.3491 96.7451 42.783C96.179 42.217 95.896 41.5095 95.896 40.684C95.896 39.8585 96.179 39.151 96.7451 38.5849C97.3112 38.0189 98.0188 37.7359 98.8208 37.7359C99.8351 37.7359 100.59 38.1604 101.109 38.9859V37.8302ZM98.8916 42.9246C99.5048 42.9246 100.047 42.7123 100.472 42.2878C100.896 41.8396 101.109 41.3208 101.109 40.684C101.109 40.0472 100.896 39.5283 100.472 39.1038C100.047 38.6557 99.5048 38.4434 98.8916 38.4434C98.2783 38.4434 97.7358 38.6557 97.3112 39.1038C96.8867 39.5283 96.6744 40.0708 96.6744 40.684C96.6744 41.2972 96.8867 41.8396 97.3112 42.2878C97.7358 42.6887 98.2547 42.9246 98.8916 42.9246Z",
    fill: "#F1FAFF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M109.27 38.5613H107.642V41.9812C107.642 42.9481 108.185 42.8774 109.27 42.8302V43.4906C107.69 43.7264 106.888 43.3019 106.888 41.9812V38.5613H105.708V37.8302H106.888V36.4623L107.642 36.2264V37.8066H109.27V38.5613Z",
    fill: "#F1FAFF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M115.403 40.0236V43.4906H114.648V40.0236C114.648 39.0095 114.082 38.4198 113.115 38.4198C112.03 38.4198 111.275 39.0802 111.275 40.5189V43.4906H110.52V35.5661H111.275V38.7029C111.699 38.0189 112.336 37.6887 113.185 37.6887C114.553 37.7123 115.403 38.6085 115.403 40.0236Z",
    fill: "#F1FAFF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M121.488 38.6085C122.007 39.1981 122.266 39.9057 122.266 40.7076C122.266 40.7783 122.266 40.9198 122.243 41.0613H117.266C117.407 42.1934 118.304 42.9245 119.53 42.9245C120.379 42.9245 121.04 42.5472 121.347 41.9576L122.007 42.3349C121.512 43.1368 120.615 43.6321 119.507 43.6321C118.61 43.6321 117.879 43.3491 117.337 42.783C116.771 42.217 116.488 41.5094 116.488 40.6604C116.488 39.8113 116.771 39.1038 117.313 38.5377C117.879 37.9717 118.563 37.6887 119.436 37.6887C120.285 37.7123 120.969 37.9953 121.488 38.6085ZM117.266 40.3302H121.488C121.417 39.7406 121.181 39.2689 120.804 38.9387C120.427 38.6085 119.955 38.4434 119.46 38.4434C118.28 38.4198 117.407 39.1981 117.266 40.3302Z",
    fill: "#F1FAFF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M129.461 35.5661C130.546 35.5661 131.442 35.9434 132.126 36.7217C132.834 37.4764 133.187 38.4198 133.187 39.5283C133.187 40.6368 132.834 41.5802 132.126 42.3585C131.418 43.1132 130.522 43.4906 129.461 43.4906H126.394V35.5661H129.461ZM129.461 42.7595C130.333 42.7595 131.041 42.4529 131.583 41.8397C132.15 41.2264 132.433 40.4481 132.433 39.5519C132.433 38.6557 132.15 37.8774 131.583 37.2642C131.017 36.651 130.333 36.3444 129.461 36.3444H127.196V42.783H129.461V42.7595Z",
    fill: "#F1FAFF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M134.414 36.8632C134.202 36.651 134.202 36.2972 134.414 36.0849C134.626 35.8727 134.98 35.8727 135.192 36.0849C135.405 36.2972 135.405 36.651 135.192 36.8632C134.98 37.0755 134.65 37.0755 134.414 36.8632ZM134.437 43.4906V37.8302H135.192V43.4906H134.437Z",
    fill: "#F1FAFF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M141.632 37.8302H142.387V43.2547C142.387 44.0802 142.103 44.717 141.537 45.1887C140.971 45.6604 140.311 45.8963 139.532 45.8963C138.212 45.8963 137.315 45.4246 136.844 44.5047L137.504 44.1274C137.834 44.8113 138.518 45.1651 139.532 45.1651C140.83 45.1651 141.632 44.434 141.632 43.2547V42.3821C141.113 43.2076 140.358 43.6321 139.344 43.6321C138.542 43.6321 137.858 43.3491 137.268 42.783C136.702 42.217 136.419 41.5095 136.419 40.684C136.419 39.8585 136.702 39.151 137.268 38.5849C137.834 38.0189 138.542 37.7359 139.344 37.7359C140.358 37.7359 141.113 38.1604 141.632 38.9859V37.8302ZM139.415 42.9246C140.028 42.9246 140.57 42.7123 140.995 42.2878C141.419 41.8396 141.632 41.3208 141.632 40.684C141.632 40.0472 141.419 39.5283 140.995 39.1038C140.57 38.6557 140.028 38.4434 139.415 38.4434C138.801 38.4434 138.259 38.6557 137.834 39.1038C137.41 39.5283 137.197 40.0708 137.197 40.684C137.197 41.2972 137.41 41.8396 137.834 42.2878C138.259 42.6887 138.778 42.9246 139.415 42.9246Z",
    fill: "#F1FAFF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M143.967 36.8632C143.755 36.651 143.755 36.2972 143.967 36.0849C144.179 35.8727 144.533 35.8727 144.745 36.0849C144.957 36.2972 144.957 36.651 144.745 36.8632C144.533 37.0755 144.179 37.0755 143.967 36.8632ZM143.967 43.4906V37.8302H144.722V43.4906H143.967Z",
    fill: "#F1FAFF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M149.298 38.5613H147.67V41.9812C147.67 42.9481 148.213 42.8774 149.298 42.8302V43.4906C147.717 43.7264 146.915 43.3019 146.915 41.9812V38.5613H145.736V37.8302H146.915V36.4623L147.67 36.2264V37.8066H149.298V38.5613Z",
    fill: "#F1FAFF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M155.076 37.8302H155.831V43.4906H155.076V42.3821C154.557 43.2076 153.803 43.6321 152.788 43.6321C151.986 43.6321 151.302 43.3491 150.713 42.783C150.147 42.217 149.864 41.5095 149.864 40.684C149.864 39.8585 150.147 39.151 150.713 38.5849C151.279 38.0189 151.986 37.7359 152.788 37.7359C153.803 37.7359 154.557 38.1604 155.076 38.9859V37.8302ZM152.836 42.9246C153.449 42.9246 153.991 42.7123 154.416 42.2878C154.84 41.8396 155.053 41.3208 155.053 40.684C155.053 40.0472 154.84 39.5283 154.416 39.1038C153.991 38.6557 153.449 38.4434 152.836 38.4434C152.222 38.4434 151.68 38.6557 151.255 39.1038C150.831 39.5283 150.618 40.0708 150.618 40.684C150.618 41.2972 150.831 41.8396 151.255 42.2878C151.68 42.6887 152.222 42.9246 152.836 42.9246Z",
    fill: "#F1FAFF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M157.411 43.4906V35.2359H158.166V43.4906H157.411Z",
    fill: "#F1FAFF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M167.672 35.5661V36.3208H165.242V43.4906H164.44V36.3208H162.011V35.5661H167.672Z",
    fill: "#F1FAFF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M168.639 38.7736C168.993 38.0896 169.583 37.7359 170.432 37.7359V38.467C169.394 38.467 168.639 39.033 168.639 40.3538V43.4906H167.884V37.8302H168.639V38.7736Z",
    fill: "#F1FAFF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M175.432 37.8302H176.187V43.4906H175.432V42.6179C175.007 43.3019 174.371 43.6321 173.521 43.6321C172.153 43.6321 171.304 42.7359 171.304 41.3208V37.8538H172.059V41.3208C172.059 42.3349 172.625 42.9245 173.592 42.9245C174.677 42.9245 175.432 42.2642 175.432 40.8255V37.8302Z",
    fill: "#F1FAFF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M179.513 40.283C180.456 40.5189 181.659 40.7783 181.659 42.0047C181.659 42.5 181.47 42.8774 181.093 43.184C180.716 43.4906 180.22 43.6321 179.631 43.6321C178.546 43.6321 177.744 43.0896 177.437 42.3349L178.074 41.9576C178.286 42.5472 178.876 42.901 179.631 42.901C180.362 42.901 180.928 42.6179 180.928 42.0047C180.928 41.4859 180.409 41.2028 179.772 41.0377C178.829 40.8019 177.626 40.5425 177.626 39.316C177.626 38.8443 177.814 38.467 178.168 38.1604C178.546 37.8538 179.017 37.6887 179.56 37.6887C180.48 37.6887 181.211 38.1368 181.541 38.8443L180.928 39.1981C180.716 38.6557 180.267 38.3962 179.56 38.3962C178.923 38.3962 178.381 38.7028 178.381 39.2925C178.357 39.8349 178.876 40.1179 179.513 40.283Z",
    fill: "#F1FAFF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M185.669 38.5613H184.041V41.9812C184.041 42.9481 184.584 42.8774 185.669 42.8302V43.4906C184.089 43.7264 183.287 43.3019 183.287 41.9812V38.5613H182.107V37.8302H183.287V36.4623L184.041 36.2264V37.8066H185.669V38.5613Z",
    fill: "#F1FAFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9261_1021",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 47,
    height: 44
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0516 3.77359H3.76416V46.2264H49.0516V3.77359Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9261_1021)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1623 13.6792L22.1387 13.6557V3.77358L22.2094 3.72641L40.6311 14.3396V14.434L32.0689 19.3632H32.0217L22.1623 13.6792Z",
    fill: "url(#paint0_linear_9261_1021)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6074 14.3868L32.0452 19.316L22.1858 13.6557V3.77359L40.6074 14.3868Z",
    fill: "url(#paint1_linear_9261_1021)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0216 30.7076L31.998 30.684V19.316L32.0216 19.2925L40.5838 14.3396L40.6546 14.3868V35.6132L40.5838 35.6604L32.0216 30.7076Z",
    fill: "url(#paint2_linear_9261_1021)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6076 14.3868V35.6132L32.0454 30.684V19.316L40.6076 14.3868Z",
    fill: "url(#paint3_linear_9261_1021)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1387 46.2264V36.3443L22.1623 36.3207L32.0217 30.6368H32.0689L40.6311 35.566V35.6604L22.2094 46.2736L22.1387 46.2264Z",
    fill: "url(#paint4_linear_9261_1021)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6074 35.6132L22.1858 46.2264V36.3443L32.0452 30.6604L40.6074 35.6132Z",
    fill: "url(#paint5_linear_9261_1021)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.74072 35.6604V35.566L12.3029 30.6368H12.3501L22.2095 36.3207L22.2331 36.3443V46.2264L22.1623 46.2736L3.74072 35.6604Z",
    fill: "url(#paint6_linear_9261_1021)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1858 36.3443V46.2264L3.76416 35.6132L12.3263 30.684L22.1858 36.3443Z",
    fill: "url(#paint7_linear_9261_1021)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.71704 35.6132V14.3868L3.7878 14.3396L12.35 19.2925L12.3736 19.316V30.684L12.35 30.7076L3.7878 35.6604L3.71704 35.6132Z",
    fill: "url(#paint8_linear_9261_1021)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3263 19.316V30.6604L3.76416 35.6132V14.3868L12.3263 19.316Z",
    fill: "url(#paint9_linear_9261_1021)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3029 19.3632L3.74072 14.434V14.3396L22.1623 3.72641L22.2331 3.77358V13.6557L22.2095 13.6792L12.3501 19.3632H12.3029Z",
    fill: "url(#paint10_linear_9261_1021)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1858 3.77359V13.6557L12.3263 19.316L3.76416 14.3868L22.1858 3.77359Z",
    fill: "url(#paint11_linear_9261_1021)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5131 45.4245L32.0217 40.5425V40.4481L40.5131 35.566H40.5603L49.0753 40.4481V40.5425L40.5603 45.4245H40.5131Z",
    fill: "url(#paint12_linear_9261_1021)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2911 42.9481L40.5368 45.4009L44.7825 42.9481L49.0282 40.4953L44.7825 38.0424L40.5368 35.5896L36.2911 38.0424L32.0454 40.4953L36.2911 42.9481Z",
    fill: "url(#paint13_linear_9261_1021)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5366 35.6604L32.0688 40.5424L31.998 40.4953V30.7311L32.0216 30.684L40.513 25.8019H40.5602L49.0752 30.684L49.0988 30.7311V40.4953L49.028 40.5424L40.5366 35.6604Z",
    fill: "url(#paint14_linear_9261_1021)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2911 38.0425L40.5368 35.5896L44.7825 38.0425L49.0282 40.4953V30.7311L44.7825 28.2783L40.5368 25.8255L36.2911 28.2783L32.0454 30.7311V40.4953L36.2911 38.0425Z",
    fill: "url(#paint15_linear_9261_1021)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3083 30L16.4307 28.349V28.2547L22.1624 24.9528H22.2095L27.9412 28.2547V28.349L22.2095 31.6509H22.1624L19.3083 30Z",
    fill: "#1A4896"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3318 29.9528L22.1859 31.6038L25.0399 29.9528L27.894 28.3019L25.0399 26.6509L22.1859 25L19.3318 26.6509L16.4778 28.3019L19.3318 29.9528Z",
    fill: "#1A4896"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1859 25.0472L16.4777 28.3491L16.407 28.3019V21.6981L16.4306 21.6509L22.1623 18.3491H22.2094L27.9411 21.6509L27.9647 21.6981V28.3019L27.894 28.3491L22.1859 25.0472Z",
    fill: "#B2D5F7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3318 26.6509L22.1859 25L25.0399 26.6509L27.894 28.3019V21.6981L25.0399 20.0472L22.1859 18.3962L19.3318 20.0472L16.4778 21.6981V28.3019L19.3318 26.6509Z",
    fill: "#B2D5F7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.407 28.3019V21.6981L16.4306 21.6509L22.1623 18.3491L22.233 18.3962V25L22.2094 25.0472L16.4777 28.3491L16.407 28.3019Z",
    fill: "#3F79D0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3318 26.6509L22.1859 25V18.3962L19.3318 20.0472L16.4778 21.6981V28.3019L19.3318 26.6509Z",
    fill: "#3F79D0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9261_1021",
    x1: 24.2218,
    y1: 7.3503,
    x2: 34.5264,
    y2: 16.9298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1274DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1665C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9261_1021",
    x1: 24.2359,
    y1: 7.36352,
    x2: 34.5009,
    y2: 16.9065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1274DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1665C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9261_1021",
    x1: 36.3206,
    y1: 16.85,
    x2: 36.3206,
    y2: 35.5941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1665C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#184FA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9261_1021",
    x1: 36.3207,
    y1: 16.8814,
    x2: 36.3207,
    y2: 35.5535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1665C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#184FA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9261_1021",
    x1: 22.5401,
    y1: 39.0627,
    x2: 32.304,
    y2: 37.754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57A0ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85BBF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_9261_1021",
    x1: 22.5813,
    y1: 39.0573,
    x2: 32.3077,
    y2: 37.7535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57A0ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85BBF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_9261_1021",
    x1: 10.2604,
    y1: 34.3807,
    x2: 20.0767,
    y2: 40.1707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A85E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57A0ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_9261_1021",
    x1: 10.279,
    y1: 34.3917,
    x2: 20.0577,
    y2: 40.1595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A85E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57A0ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_9261_1021",
    x1: 8.0499,
    y1: 19.2085,
    x2: 8.0499,
    y2: 30.6908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#036AE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A85E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_9261_1021",
    x1: 8.04984,
    y1: 19.2306,
    x2: 8.04984,
    y2: 30.6691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#036AE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A85E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_9261_1021",
    x1: 19.756,
    y1: 6.70497,
    x2: 10.0129,
    y2: 17.2144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1274DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#036AE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_9261_1021",
    x1: 19.7441,
    y1: 6.718,
    x2: 10.0385,
    y2: 17.1873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1274DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#036AE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_9261_1021",
    x1: 40.5438,
    y1: 35.5693,
    x2: 40.5438,
    y2: 45.4205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#184FA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A4896"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_9261_1021",
    x1: 40.5438,
    y1: 35.6108,
    x2: 40.5438,
    y2: 45.3795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#184FA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A4896"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_9261_1021",
    x1: 31.8917,
    y1: 34.3996,
    x2: 49.5172,
    y2: 32.7146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85BBF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2D5F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_9261_1021",
    x1: 31.9362,
    y1: 34.398,
    x2: 49.4698,
    y2: 32.7217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85BBF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2D5F7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuanteralogo);
export default __webpack_public_path__ + "static/media/quanteralogo.fd742844d3072315e6c7c9e5ee68c91e.svg";
export { ForwardRef as ReactComponent };